// extracted by mini-css-extract-plugin
export default {"input-group":"TextArea-module__input-group__LDIwB","input":"TextArea-module__input__qebgO","label":"TextArea-module__label__SAWdt","is-active":"TextArea-module__is-active__d1FT4"};